__turbopack_context__.v({
  "iconSlot": "MUKeGG_iconSlot",
  "label": "MUKeGG_label",
  "styledCta": "MUKeGG_styledCta",
});
